module.exports = __webpack_public_path__ + "img/anw-hiaatverzekering.0fe2981f.png";